// extracted by mini-css-extract-plugin
export default {"confirmSection":"SystemErrorMessage_confirmSection__4C9ha","errorIcon":"SystemErrorMessage_errorIcon__VFsg-","confirmBold":"SystemErrorMessage_confirmBold__5djvP"};